module.exports = __webpack_public_path__ + "static/01-3a116707f47242b5e7a93dcb33fbbe58.jpg";